// Reuses Loox's own "(count)" label but adds the numeric rating + "N REVIEWS"
// text alongside it, matching the fallback markup shown in the quick view
// popup (see atlas.skio-dynamic-box.js enhanceLooxWidget/renderLooxFallback).
const STAR_SVG =
    '<svg class="skio-dynamic-box__loox-fallback-star" viewBox="0 0 24 24" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>';

function enhanceLooxWidget(looxEl) {
    const content = looxEl.querySelector(".loox-rating-content");
    if (
        !content ||
        content.querySelector(".skio-dynamic-box__loox-rating-extra")
    ) {
        return;
    }

    const rating = parseFloat(looxEl.getAttribute("data-rating")) || 0;
    const raters = parseInt(looxEl.getAttribute("data-raters"), 10) || 0;
    if (!rating || !raters) return;

    content.insertAdjacentHTML(
        "beforeend",
        `
            <span class="skio-dynamic-box__loox-rating-extra">
                <span class="skio-dynamic-box__loox-fallback-rating">${rating.toFixed(1)}</span>
                <span class="skio-dynamic-box__loox-fallback-count">${raters} REVIEWS</span>
            </span>
        `
    );
}

function renderLooxFallback(looxEl) {
    const rating = parseFloat(looxEl.getAttribute("data-rating")) || 0;
    const raters = parseInt(looxEl.getAttribute("data-raters"), 10) || 0;

    if (!raters) {
        looxEl.closest("product-reviews")?.remove();
        return;
    }

    const percent = Math.max(0, Math.min(100, (rating / 5) * 100));
    const starsRow = Array.from({ length: 5 })
        .map(() => STAR_SVG)
        .join("");

    looxEl.outerHTML = `
        <div class="skio-dynamic-box__loox-fallback">
            <div class="skio-dynamic-box__loox-fallback-stars">
                <div class="skio-dynamic-box__loox-fallback-stars-track">${starsRow}</div>
                <div class="skio-dynamic-box__loox-fallback-stars-fill" style="width: ${percent}%">${starsRow}</div>
            </div>
            <span class="skio-dynamic-box__loox-fallback-rating">${rating.toFixed(1)}</span>
            <span class="skio-dynamic-box__loox-fallback-count">${raters} REVIEWS</span>
        </div>
    `;
}

function watchLooxWidget(looxEl) {
    const alreadyRendered = () => !!looxEl.querySelector(".loox-rating-content");

    if (alreadyRendered()) {
        enhanceLooxWidget(looxEl);
        return;
    }

    const observer = new MutationObserver(() => {
        if (alreadyRendered()) {
            observer.disconnect();
            clearTimeout(fallbackTimer);
            enhanceLooxWidget(looxEl);
        }
    });
    observer.observe(looxEl, { childList: true, subtree: true });

    const fallbackTimer = setTimeout(() => {
        observer.disconnect();
        if (!looxEl.isConnected) return;
        if (alreadyRendered()) {
            enhanceLooxWidget(looxEl);
            return;
        }
        renderLooxFallback(looxEl);
    }, 1200);
}

document
    .querySelectorAll("[data-atlas-product-review-custom] .loox-rating")
    .forEach(watchLooxWidget);
